import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ChevronLeft, Trophy, Users, Target } from "lucide-react";
import PhoneFrame from "../components/PhoneFrame.jsx";
import api from "../lib/api.js";

export default function Challenges() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  const load = () => api.get("/challenges").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (ch) => {
    if (ch.is_joined) await api.post("/challenges/leave", { challenge_id: ch.id });
    else {
      await api.post("/challenges/join", { challenge_id: ch.id });
      toast.success("Joined challenge");
    }
    load();
  };

  return (
    <PhoneFrame>
      <div className="px-5 pt-6 pb-28">
        <button onClick={() => nav(-1)} className="text-slate-400 inline-flex items-center gap-1 text-sm" data-testid="challenges-back">
          <ChevronLeft size={16} /> Back
        </button>
        <h1 className="ps-heading text-3xl font-bold mt-4">Challenges</h1>
        <p className="text-slate-400 text-sm">Daily, weekly and monthly missions.</p>

        <div className="mt-6 space-y-3">
          {items.map((c) => (
            <div key={c.id} className="ps-card p-5" data-testid={`challenge-${c.id}`}>
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="text-[10px] uppercase tracking-widest font-bold text-[#2fbf71]">{c.type}</div>
                  <div className="ps-heading text-lg font-semibold mt-1">{c.title}</div>
                  <div className="text-sm text-slate-400 mt-1">{c.description}</div>
                  <div className="mt-3 flex gap-3 text-xs text-slate-400">
                    <span className="inline-flex items-center gap-1"><Trophy size={12} color="#F59E0B" /> {c.points_reward} pts</span>
                    <span className="inline-flex items-center gap-1"><Users size={12} /> {c.participant_count}</span>
                    {c.target_steps > 0 && <span className="inline-flex items-center gap-1"><Target size={12} /> {c.target_steps.toLocaleString()} steps</span>}
                  </div>
                </div>
                <button
                  data-testid={`challenge-join-${c.id}`}
                  onClick={() => toggle(c)}
                  className={c.is_joined
                    ? "px-4 py-2 rounded-full border border-[#1a2f40] text-sm text-slate-300"
                    : "ps-button-primary px-4 py-2 text-sm"
                  }
                >{c.is_joined ? "Leave" : "Join"}</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PhoneFrame>
  );
}
